import {css, StyleSheet} from 'aphrodite';
import React, {useEffect, useState} from 'react';

import Chip, {ChipSize} from 'ui-library/chips/Chip';
import MultiSelectSearchableDropdown from 'ui-library/dropdowns/MultiSelectSearchableDropdown';
import {OptionData} from 'ui-library/menus/MenuConstants';

/** @package */
export interface MultiSelectOptionSearchCellDropdownProps {
  isSelected: boolean;
  onOpenDropdown?: (() => void) | null;
  onUpdate: (selectedOptions: Array<string>) => void;
  options: Array<string | OptionData>;
  selectedOptions: Array<string>;
}

export default function MultiSelectOptionSearchCellDropdown({
  options,
  selectedOptions,
  onOpenDropdown,
  onUpdate,
  isSelected,
}: MultiSelectOptionSearchCellDropdownProps): JSX.Element {
  const [isOpen, setOpen] = useState(isSelected);

  const optionDatas: Array<OptionData> = options.map((option) =>
    typeof option === 'string'
      ? {
          name: option,
          value: option,
        }
      : option
  );

  useEffect(() => {
    if (!isSelected) {
      setOpen(false);
    }
  }, [isSelected]);

  function handleOnToggle(isOpen: boolean): void {
    if (isOpen) {
      onOpenDropdown?.();
    }
    setOpen(isOpen);
  }

  return (
    <MultiSelectSearchableDropdown
      buttonClassName={css(styles.dropdown)}
      isOpen={isOpen}
      noneSelectedMessage=""
      onSelect={onUpdate}
      onToggle={handleOnToggle}
      optionDatas={optionDatas}
      renderSelectedValues={(selectedOptions) =>
        selectedOptions.map((option, index) => (
          <Chip
            actionIcon="cross-thick"
            className={css(styles.chip)}
            key={index}
            size={ChipSize.TABLE_CELL}
            text={option}
            onAction={() => {
              onUpdate(selectedOptions.filter((options) => options !== option));
            }}
          />
        ))
      }
      selectedValues={selectedOptions}
    />
  );
}

export const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
  },
  dropdown: {
    border: 'none',
    backgroundColor: 'transparent',
    borderColor: 'transparent',
  },
  chip: {
    marginTop: 2,
    marginBottom: 2,
  },
});
